import { useForm } from "react-hook-form"
import type { IAccountReward } from "@apis/rewards/types"
import { Loader2 } from "lucide-react"
import { Button } from "@components/ui/button"
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@components/ui/select"
import {
  Form,
  FormField,
  FormItem,
  FormControl,
  FormMessage,
} from "@components/ui/form"

type TRewardDetailProps = {
  onSubmit: (values: TReissueRewardForm) => void
  onCancel: (setter: boolean) => void
  reward: IAccountReward
  isPending: boolean
}

export type TReissueRewardForm = {
  channel_code: string
}

export function ReissueRewardForm({
  onSubmit,
  onCancel,
  reward,
  isPending,
}: TRewardDetailProps) {
  const form = useForm<TReissueRewardForm>({
    mode: "onTouched",
    defaultValues: { channel_code: "" },
  })

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="tw:flex tw:gap-3 tw:space-y-3"
      >
        <FormField
          control={form.control}
          name="channel_code"
          rules={{ required: "Fulfillment channel is required" }}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Select onValueChange={field.onChange} value={field.value}>
                  <SelectTrigger className="tw:w-auto tw:min-w-[250px]">
                    <SelectValue placeholder="Select fulfillment channel" />
                  </SelectTrigger>
                  <SelectContent>
                    {reward.fulfillment_channels.map((channel) => (
                      <SelectItem key={channel.code} value={channel.code}>
                        {channel.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <Button type="submit" disabled={!form.formState.isValid}>
          {isPending ? (
            <>
              <Loader2 className="tw:mr-2 tw:size-4 tw:animate-spin" />
              Submitting...
            </>
          ) : (
            "Submit"
          )}
        </Button>

        <Button
          type="button"
          variant="destructive"
          onClick={() => onCancel(false)}
        >
          Cancel
        </Button>
      </form>
    </Form>
  )
}
